// extracted by mini-css-extract-plugin
export default {"singleProject":"singleProject_singleProject__v6vCH","actionIcons":"singleProject_actionIcons__ocexh"};